import Alpine from "alpinejs";
import { get } from "js-cookie";

Alpine.magic("getCookie", () => (name) => {
    return get(name);
});
